module.exports = __webpack_public_path__ + "static/img/rddExpenseTax_bg_1.0accc68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/rddExpenseTax/rddExpenseTax_bg_1.png
// module id = zUxr
// module chunks = 34